import React from 'react';
import {Avatar, List} from 'antd';
import PropTypes from 'prop-types';
import styles from './index.less';

export class TabContent extends React.Component {
  static propTypes = {
    data: PropTypes.array.isRequired,
    onClick: PropTypes.func
  };

  getMessageIconName(type) {
    switch (type) {
      case 'WARNING':
        return 'warning';
      case 'INFO':
        return 'info';
      case 'ALERT':
        return 'exclamation';
      default:
        return 'user'
    }
  }

  getMessageIconColor(type) {
    switch (type) {
      case 'WARNING':
        return 'orange';
      case 'INFO':
        return 'green';
      case 'ALERT':
        return 'red';
      default:
        return 'green'
    }
  }

  generateMessageContent(text) {
    return (
      <p dangerouslySetInnerHTML={{__html: text}}></p>
    )
  }

  render() {
    return (
      <List
        itemLayout="horizontal"
        dataSource={this.props.data}
        renderItem={item => (
          <List.Item key={item.id} className={styles["item-list"]}
                     onClick={this.props.onClick ? this.props.onClick(item.id) : null}>
            <List.Item.Meta
              avatar={<Avatar icon={this.getMessageIconName(item.mType)}
                              style={{backgroundColor: this.getMessageIconColor(item.mType)}}/>}
              title={item.title}
              description={this.generateMessageContent(item.text)}
            />
          </List.Item>
        )}
      />
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/layout/notifications/tab-content.js